import styled from '@emotion/styled';
import { ClassAttributes, createElement, ReactNode } from 'react';
import Dropzone from 'react-dropzone';
import { withStateHandlers } from 'recompose';

import theme from '../../../../theme';
import _Indicator from './Indicator';

type Props = ClassAttributes<HTMLElement> & {
  onDrop: (files: FileList) => void;
  onChangeDragging?: (isDragging: boolean) => void;
  className?: string;
  children?: ReactNode;
};

const FileDndable = withStateHandlers(
  (_: Props) => ({
    isDragging: false,
  }),
  {
    onDragOver: (_: any, { onChangeDragging }: Props) => () => {
      if (onChangeDragging) onChangeDragging(true);

      return { isDragging: true };
    },
    onDragLeave: (_: any, { onChangeDragging }: Props) => () => {
      if (onChangeDragging) onChangeDragging(false);

      return { isDragging: false };
    },
    _onDrop: (_: any, { onChangeDragging, onDrop }: Props) => (accepted: FileList) => {
      if (onChangeDragging) onChangeDragging(false);

      onDrop(accepted);

      return { isDragging: false };
    },
  },
)(({ className, children, isDragging, onDragOver, onDragLeave, _onDrop }) => (
  // @ts-expect-error
  <Root onDragOver={onDragOver} onDragLeave={onDragLeave} onDrop={_onDrop} disableClick className={className}>
    {children}

    <Indicator visible={isDragging} />
  </Root>
));

const Root = styled(Dropzone)({
  position: 'relative',
});

const Indicator = styled(_Indicator)<{ visible: boolean }>(({ visible }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  opacity: visible ? 1 : 0,
  visibility: visible ? 'visible' : 'hidden',
  transition: visible
    ? `opacity ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut} 0ms,
       visibility 0ms linear 0ms`
    : `opacity ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut} 0ms,
       visibility 0ms linear ${theme.transitions.duration.standard}ms`,
}));

export default FileDndable;
